const { SHIPMENT_TYPE_ALL_TYPES } = require('../../shipment')
const { joinRemarks, aggregateQuantitiesBySku, updateCountsFromSkuQuantities } = require('../utils')

function createSalesReturn ({ mainApi, logger, batches }) {
  return async function salesReturn (params) {
    if (!params) {
      const err = new Error('salesReturn: params parameter is required')
      err.status = 400
      throw err
    }
    const payload = Array.isArray(params) ? params[0] : params
    if (typeof payload.sales_return_reference === 'undefined') {
      const err = new Error('salesReturn: sales_return_reference parameter is required')
      err.status = 400
      throw err
    }
    const entryItems = Array.isArray(payload.items) ? payload.items : []
    if (entryItems.length === 0) {
      const err = new Error(`salesReturn: items missing for sales_return_reference: ${payload.sales_return_reference}`)
      err.status = 400
      throw err
    }
    let originalShipment
    try {
      originalShipment = await mainApi.shipment.getShipmentByNumber({ shipmentNumber: payload.sales_return_reference })
    } catch (err) {
      const error = new Error(`Shipment not found: ${payload.sales_return_reference}: ${err}`)
      error.status = 404
      throw error
    }
    if (!originalShipment) {
      const err = new Error(`Shipment not found: ${payload.sales_return_reference}`)
      err.status = 404
      throw err
    }

    const unifiedRemarks = joinRemarks(entryItems.map(item => item.remarks))

    await batches.fromSalesReturn(entryItems)

    const salesReturnQuantities = aggregateQuantitiesBySku(
      entryItems,
      (item) => Number(item.accepted_quantity) || 0,
      {
        getBatchEntries: (item) => {
          if (!item || !item.batch_number) return []
          return [{
            batchNumber: item.batch_number,
            quantity: Number(item.accepted_quantity) || 0
          }]
        }
      }
    )
    const counts = updateCountsFromSkuQuantities(originalShipment.counts, salesReturnQuantities)
    try {
      const count = await mainApi.shipment.listLastMileDeliveries({
        filters: { shipment_id: originalShipment.id, status: ['received'] },
        onlyCount: true,
        addSnapshotsData: false,
        deliveryType: SHIPMENT_TYPE_ALL_TYPES
      })
      if (count && count > 0) {
        return
      }
    } catch (_) {
      if (logger && logger.warn) {
        logger.warn({ code: 'received-snapshot-already-exists', orderId: originalShipment.orderId })
      }
    }

    const [snapshotData] = await mainApi.shipment.decorateShipmentSnapshotsWithResolvedPrices([{
      ...originalShipment,
      doCheckSent: false,
      counts,
      comment: unifiedRemarks,
      status: 'received'
    }])

    console.log('Creating sales return snapshot with data:', {
      orderId: snapshotData.orderId,
      status: snapshotData.status,
      comment: snapshotData.comment,
      countsKeys: Object.keys(snapshotData.counts || {})
    })
    await mainApi.shipment.createSnapshot(snapshotData)
  }
}

module.exports = createSalesReturn
